import { Box, Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { BBPLMonitorForCreditFacility } from 'packages/bbplMonitor/ui/BBPLMonitorForCreditFacility';
import CreditFacilityProvider, {
  useCreditFacilityContext,
} from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

const BBPLMonitorWithCreditFacilitySelector = () => {
  const { user } = useUserAuthOrThrow();
  const { creditFacilityId } = useCreditFacilityContext();

  return (
    <Box p="40px">
      <Box w="500px" mb="32px">
        <CreditFacilitySelect organizationId={user.organizationId} />
      </Box>
      <BBPLMonitorForCreditFacility creditFacilityId={creditFacilityId} />
    </Box>
  );
};

export const BBPLMonitorRoute = () => {
  const flags = useFeatureFlags();
  const { user } = useUserAuthOrThrow();

  // we shouldnt reach here if flag is not enabled
  if (!flags.showGraphMonitor) {
    return <Navigate to="/" />;
  }

  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <CreditFacilityProvider
        renderLoading={<Skeleton />}
        organizationId={user.organizationId}
        fallbackComponent={<Navigate to="/" />}
      >
        <BBPLMonitorWithCreditFacilitySelector />
      </CreditFacilityProvider>
    </RouteErrorBoundary>
  );
};
